import StatusBarButton from '../layout/StatusBarButton';

const PlantTaskNotExecutable = ({ onDelete }) => {
  return (
    <div className="plant-task-list centered">
       <div className="plant-task-not-executable-container">
          <h4>This plant task can not be executed.</h4>
        
        <StatusBarButton
          type="inline"
          label="Confirm"
          icon="fas fa-check"
          reversed={true}
          statusSlot={5}
          clickHandler={onDelete}
        />
      </div>
    </div>
  );
};

export default PlantTaskNotExecutable;
